import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import { useQueryClient } from "@tanstack/react-query";
import { useAtomValue, useSetAtom } from "jotai";
import { noop } from "lodash";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KEY_CODES } from "../../../constants";
import { setViewTemplatesOpen } from "../../../stores/jotai/base";
import { discoverySessionAtom } from "../../../stores/jotai/discovery-session";
import { setSelectedTemplate, templatesAtom } from "../../../stores/jotai/template/templates";
import { useCreateTemplate } from "../../../tanstackQuery/queries/templates";

const SAVE_BUTTON_IDS = {
    SAVE: 1,
    SAVE_AND_OPEN: 2,
}

const TemplateCreationForm = (props) => {
    const { onClose, inline, onSuccess: onSuccessFromProps, showSaveAndOpenButton,user,team,setBase } = props;
    const [newTemplateName, setNewTemplateName] = useState<null | string>(null);
    const [clickedButtonID, setClickedButtonID] = useState<null | number>(null);
    const [isCreating, setIsCreating] = useState<boolean>(false);
    const { keycloak } = useKeycloak();
    const navigate = useNavigate()
    const setTemplatesAtomState = useSetAtom(templatesAtom);
    const discoverySession = useAtomValue(discoverySessionAtom);


    const client = useQueryClient();

    const { mutateAsync: createNewTemplate } = useCreateTemplate(
      { accessToken: keycloak.token },
      {
        onSuccess: (response) => {
          client.invalidateQueries({ queryKey: ["templates"] });
          if(clickedButtonID === 2) {
            openCreatedTemplate(response);
            onSuccessFromProps();
          }
        }
      }
    );

    const handleTemplateNameChange = (event) => {
        setNewTemplateName(event.target.value);
    };
    
    const openCreatedTemplate = (template) => {
        setViewTemplatesOpen(setBase, true);
       // setSelectedTemplate(setTemplatesAtomState, template);
    }

    const handleSaveButtonClick = () => {
        setClickedButtonID(SAVE_BUTTON_IDS.SAVE);
        createTemplate({ onSuccess: onSuccessFromProps });
    }

    const handleSaveAndOpenButtonClick = () => {
        setClickedButtonID(SAVE_BUTTON_IDS.SAVE_AND_OPEN);
        createTemplate({ onSuccess: onSuccessFromProps });
    }

    const createTemplate = ({ onSuccess = noop }) => {
        let sid = undefined;

        try {
            //@ts-ignore
            sid = window.__sid;
        } catch (e) {}

        setIsCreating(true);
        createNewTemplate({
          groupID: team.groupID,
          sid: sid,
          data: "",
          created: new Date().toUTCString(),
          name: newTemplateName,
          userID: user.userID,
          sessionID: discoverySession?.sessionID
        })
          .then((response) => {
            onSuccess(response);
          })
          .catch((err) => {})
          .finally(() => {
            setIsCreating(false);
            setClickedButtonID(null);
          });
    };

    return (
        <Stack direction={inline ? "row" : "column"} spacing={1}>
            <TextField
                size="small"
                label="Template Name"
                value={newTemplateName}
                onChange={handleTemplateNameChange}
                onKeyDown={(event) => {
                    if (event.keyCode === KEY_CODES.ENTER) {
                        handleSaveButtonClick();
                    }
                }}
            />
            <Stack
                direction="row"
                justifyContent="flex-end"
                spacing={1}
            >
                <Button
                    variant="outlined"
                    onClick={onClose}
                >
                    Cancel
                </Button>
                {showSaveAndOpenButton && (
                    <Button
                        disabled={!newTemplateName}
                        variant="outlined"
                        endIcon={
                            isCreating &&
                            clickedButtonID === SAVE_BUTTON_IDS.SAVE_AND_OPEN ? (
                                <CircularProgress size={16} />
                            ) : null
                        }
                        onClick={handleSaveAndOpenButtonClick}
                    >
                        Save & Open
                    </Button>
                )}
                <Button
                    variant="contained"
                    disabled={!newTemplateName}
                    endIcon={
                        isCreating && clickedButtonID === SAVE_BUTTON_IDS.SAVE ? (
                            <CircularProgress
                                size={16}
                                sx={{ color: "white" }}
                            />
                        ) : null
                    }
                    onClick={handleSaveButtonClick}
                >
                    Save
                </Button>
            </Stack>
        </Stack>
    );
};

export default TemplateCreationForm;
